import { connect } from '@atlassian/jira-react-redux';
import type { AppState } from '../../../state/types';
import { projectKeyMaxLength, projectNameMaxLength } from '../../../state/ui/selectors';
import FormInput from './view';

const mapStateToProps = (state: AppState) => ({
	projectNameMaxLength: projectNameMaxLength(state),
	projectKeyMaxLength: projectKeyMaxLength(state),
});

export default connect(mapStateToProps, {})(FormInput);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { BaseProps } from './view';
